import importerStore from '@shared/importer/importer-store';
import { SubpropertyService } from '@modules/subproperty/subproperty-service';
import subpropertyImporterFields from '@modules/subproperty/subproperty-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  SubpropertyService.import,
  subpropertyImporterFields,
  i18n('entities.subproperty.importer.fileName'),
  i18n('entities.subproperty.importer.hint'),
);
